/**
 * @ngdoc overview
 * @name publishing
 * @description
 * # publishing
 *
 * Application Module.
 */
angular.module('publishing', [
    // 'ngAnimate',
    'ngCookies',
    'ngMessages',
    'ngResource',
    'ui.router',
    'ui.sortable',
    'ngScrollbars',
    'ngTouch',
    'ngJcrop',
    'monospaced.elastic',
    'toArrayFilter',
    'dateRangeFilter',
    'ui.bootstrap',
    'ui.tinymce',
    'debounceModule',
    'ngTagsInput',
    'throttleModule',
    'datatables',
    'ngImgCrop',
    'ngResource',
    'ngSanitize']);

window.publishingApp = angular.module('publishing');
window.publishingApp.config(['$stateProvider', '$urlRouterProvider', '$locationProvider', '$httpProvider', 'ngJcropConfigProvider', '$compileProvider', '$provide', '$sceDelegateProvider', function ($stateProvider, $urlRouterProvider, $locationProvider, $httpProvider, ngJcropConfigProvider, $compileProvider, $provide, $sceDelegateProvider) {
    $httpProvider.interceptors.push('publishingHttpInterceptor');
    $provide.decorator('$log', ['$delegate', 'exceptionHandler', function ($delegate, exceptionHandler) {
        // stop from running the function several times on a single $log instance
        exceptionHandler.enabled = true;
        // when $log is used find out which type was used and apply exceptionHandler service to it
        var methods = {
            // find out which $log type was used
            error: function () {
                if (exceptionHandler.enabled) {
                    $delegate.error.apply($delegate, arguments);
                    exceptionHandler.error.apply(null, arguments);
                }
            },
            log: function () {
                if (exceptionHandler.enabled) {
                    $delegate.log.apply($delegate, arguments);
                    exceptionHandler.log.apply(null, arguments);
                }
            },
            info: function () {
                if (exceptionHandler.enabled) {
                    $delegate.info.apply($delegate, arguments);
                    exceptionHandler.info.apply(null, arguments);
                }
            },
            warn: function () {
                if (exceptionHandler.enabled) {
                    $delegate.warn.apply($delegate, arguments);
                    exceptionHandler.warn.apply(null, arguments);
                }
            }
        };
        return methods;
    }]);


    $sceDelegateProvider.resourceUrlWhitelist([
        // Allow same origin resource loads.
        'self',
        // Allow loading from our assets domain.  Notice the difference between * and **.
        'https://cdn01.alison-static.net/**'
    ]);

    // [optional] To change the jcrop configuration
    ngJcropConfigProvider.setJcropConfig({
        bgColor: 'black',
        bgOpacity: 0.9,
        boxWidth: 310,
        aspectRatio: 0
    });

    $urlRouterProvider.otherwise('/');
    $locationProvider.html5Mode(true);
    var userFound;
    $stateProvider
        .state('no-permission', {
            url: "/no-permission",
            templateUrl: "/angular/views/no-permission.html",
            controller: function ($scope) {
                $scope.logout_url = document.getElementById("main-doc").dataset.login_url;
            }
        })
        .state('home', {
            url: "/home",
            templateUrl: "/angular/views/home.html",
            controller: function ($scope) {
                $scope.login_url = document.getElementById("main-doc").dataset.login_url;
            }
        })
        .state('logout', {
            url: "/logout",
            controller: function () {
                window.location.href = '/logout';
            }
        })
        .state('index', {
            url: "/",
            templateUrl: "/angular/views/dashboard.html",
            controller: 'dashboardCtrl',
            resolve: {
                user: function (userService) {
                    userFound = userService.resolveUser();
                    if (userFound) {
                        return userFound;
                    } else {
                        window.location.href = document.getElementById("main-doc").dataset.login_url;
                    }
                }
            }
        })
        .state('all-notifications', {
            url: "/all-notifications",
            templateUrl: "/angular/views/notifications.html",
            controller: 'notificationsCtrl',
            resolve: {
                user: function (userService) {
                    return userService.resolveUser();
                }
            }
        })
        .state('admin', {
            url: "/admin",
            templateUrl: "/angular/views/admin.html",
            controller: "adminController",
            resolve: {
                user: function (userService) {
                    return userService.resolveUser();
                }
            }
        })
        .state('publishers-payouts', {
            url: "/admin/publishers-payouts",
            templateUrl: "/angular/views/admin/publishers-payouts.html",
            controller: "publishersController",
            resolve: {
                user: function (userService) {
                    return userService.resolveUser();
                }
            }
        })
        .state('publishers', {
            url: "/admin/publishers",
            templateUrl: "/angular/views/admin/publishers.html",
            controller: "publishersController",
            resolve: {
                user: function (userService) {
                    return userService.resolveUser();
                }
            }
        })
        .state('contractors', {
            url: "/admin/pcms/:id/contractors",
            templateUrl: "/angular/views/admin/contractors.html",
            controller: "publishersController",
            resolve: {
                user: function (userService) {
                    return userService.resolveUser();
                }
            }
        })
        .state('create-publisher', {
            url: "/admin/publishers/create",
            templateUrl: "/angular/views/admin/publishersForm.html",
            controller: "publishersController",
            resolve: {
                user: function (userService) {
                    return userService.resolveUser();
                }
            }
        })
        .state('edit-publisher', {
            url: "/admin/publishers/:id/edit",
            templateUrl: "/angular/views/admin/publishersForm.html",
            controller: "publishersController",
            resolve: {
                user: function (userService) {
                    return userService.resolveUser();
                }
            }
        })
        .state('publisher-users', {
            url: "/admin/publishers/:id/users",
            templateUrl: "/angular/views/admin/publishersUsers.html",
            controller: "publishersController",
            resolve: {
                user: function (userService) {
                    return userService.resolveUser();
                }
            }
        })
        .state('organization', {
            url: "/admin/publisher/:id",
            templateUrl: "/angular/views/admin/organizations-page.html",
            controller: "publishersController",
            resolve: {
                user: function (userService) {
                    return userService.resolveUser();
                }
            }
        })
        .state('report-courses-performance', {
            url: "/admin/publishers/:id/courses-performance",
            templateUrl: "/angular/views/admin/courses-performance-page.html",
            controller: "publishersController",
            resolve: {
                user: function (userService) {
                    return userService.resolveUser();
                }
            }
        })
        .state('report-financial', {
            url: "/admin/publishers/:id/report-financial",
            templateUrl: "/angular/views/admin/courses-performance-page.html",
            controller: "publishersController",
            resolve: {
                user: function (userService) {
                    return userService.resolveUser();
                }
            }
        })
        .state('reports', {
            url: '/reports',
            templateUrl: "/angular/views/admin/reports.html",
            controller: "reportsController",
            resolve: {
                user: function (userService) {
                    return userService.resolveUser();
                }
            }
        })
        .state('report', {
            url: '/report/:id',
            templateUrl: "/angular/views/admin/report.html",
            controller: "reportsController",
            resolve: {
                user: function (userService) {
                    return userService.resolveUser();
                }
            }
        })
}])
    .run(function ($rootScope, $http, $state, $window, $cookies) {

        // catch console errors
        $rootScope.logOfConsole = [];
        var _error = console.error;
        $rootScope.typeOf = function (name) {
            return typeof name;
        }
        console.error = function () {
            $rootScope.logOfConsole.push({ method: 'error', arguments: arguments });
            return _error.apply(console, arguments);
        };

        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            $rootScope.toState = toState;
            $rootScope.toParams = toParams;
            $rootScope.fromState = fromState;
            $rootScope.fromParams = fromParams;


            $("#ui-view").html("");
            $(".page-loading").removeClass("hidden");
            $rootScope.stateName = toState.name;

            //Used to link to external url for login
            if (toState.external) {
                event.preventDefault();
                $window.open(toState.url, '_self');
            }
        });
    })
    .filter('beautify', function () {
        return function (input) {
            input = input.replace(/_/g, ' ');
            return (angular.isString(input) && input.length > 0) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : input;
        }
    })
    .filter('score', function () {
        return function (input) {
            return (Number.isInteger(input)) ? input : Number.parseFloat(input.toFixed(1));
        }
    })
    .filter('cents', function () {
        return function (input) {
            var euros = parseInt(input) / 100;
            return euros.toLocaleString('en-IE', { style: 'currency', currency: 'EUR' });
        };
    })
    .directive('centsToEuro', function () {
        return {
            restrict: 'EA',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                var toEuros = function (value) {
                    if (typeof (value) === typeof undefined || value === null) {
                        return value;
                    }

                    var parsedValue = value.toString().replace(/[^\dA-Za-z]/g, '').trim();
                    var euros = parseInt(parsedValue) / 100;
                    if (isNaN(value) && value.charAt(0) !== '€') {
                        euros = 0;
                    }
                    return euros.toLocaleString('en-IE', { style: 'currency', currency: 'EUR' });
                }

                var toCents = function (value) {
                    if (typeof (value) === typeof undefined || value === null) {
                        return value;
                    }
                    var parsedValue = parseInt(value.toString().replace(/[^\dA-Za-z]/g, '').trim());
                    if (isNaN(parsedValue)) {
                        return 0;
                    }
                    return parsedValue;
                }

                var parseViewValue = function (value) {
                    var viewValue = toEuros(value);
                    ngModel.$viewValue = viewValue;
                    ngModel.$render();

                    // Return what we want the model value to be
                    return toCents(viewValue);
                }

                var formatModelValue = function (value) {
                    var modelValue = toCents(value);
                    ngModel.$modelValue = toCents(value);
                    return toEuros(modelValue);
                }

                ngModel.$parsers.push(parseViewValue);
                ngModel.$formatters.push(formatModelValue);
            }
        }
    })
    .directive('onErrorSrc', function () {
        return {
            link: function (scope, element, attrs) {
                element.bind('error', function () {
                    if (attrs.src != attrs.onErrorSrc) {
                        attrs.$set('src', attrs.onErrorSrc);
                    }
                });
            }
        }
    })
    .directive('restrictToMaxTags', function () {
        var KEY_BACKSPACE = 8;
        return {
            require: 'ngModel',
            priority: -10,
            link: function (scope, element, attrs, ngModelController) {
                var tagsInputScope = element.isolateScope(),
                    maxTags,
                    getTags,
                    checkTags,
                    getTagsLength,
                    checkTagsLength,
                    processLength,
                    maxTagsReached,
                    input = element.find('input'),
                    placeholder;

                attrs.$observe('maxTags', function (_maxTags) {
                    maxTags = _maxTags;
                });

                getTags = function () {
                    return ngModelController.$modelValue;
                };

                getTagsLength = function () {
                    return ngModelController.$modelValue ? ngModelController.$modelValue.length : -1;
                };

                processLength = function (len) {
                    if (len >= maxTags) {
                        placeholder = input.attr('placeholder');
                        input.attr('placeholder', '');
                        input.css('width', '10px');
                        maxTagsReached = true;
                    } else if (maxTagsReached) {
                        input.attr('placeholder', placeholder);
                        input.css('width', '');
                        maxTagsReached = false;
                    }
                };

                checkTags = function () {
                    var tags = getTags();
                    processLength(tags ? tags.length : -1);
                };

                checkTagsLength = function () {
                    var length = getTagsLength();
                    processLength(length);
                };

                scope.$watch(getTags, checkTags);
                scope.$watch(getTagsLength, checkTagsLength);

                // prevent any keys from being entered into
                // the input when max tags is reached
                input.on('keydown', function (event) {
                    if (maxTagsReached && event.keyCode !== KEY_BACKSPACE) {
                        event.stopImmediatePropagation();
                        event.preventDefault();
                    }
                });

                // prevent the autocomplete from being triggered
                input.on('focus', function (event) {
                    checkTags();
                    if (maxTagsReached) {
                        tagsInputScope.hasFocus = true;
                        event.stopImmediatePropagation();
                    }
                });
            }
        };
    })
    .directive('file', function () {
        return {
            scope: {
                file: '='
            },
            link: function (scope, el, attrs) {
                el.bind('change', function (event) {
                    var file = event.target.files[0];
                    scope.file = file ? file : {};
                    scope.$apply();
                });
            }
        };
    })
    .directive('loadCarouselDirective', function () {
        return function (scope, element, attrs) {
            if (scope.$last) {
                setTimeout(function () {
                    // jQuery
                    jQuery('.carousel-container').slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true,
                        fade: true,
                    });

                }, 100);
            }
        };
    })
    .directive('onRepeatFinishedDirective', function ($rootScope, $timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attr) {
                if (scope.$last == true) {
                    $timeout(function () {
                        $rootScope.$broadcast('ngRepeatFinished');
                        $rootScope.$emit('ngRepeatFinished');
                    }, 0);
                }
            }
        };
    }); // onRepeatFinishedDirective v.1.4
